/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Err_Tournament_Cannot_Alter_SeatingInputs */



/**
* | output |
* | --- |
* | "Cannot alter seating in this state" |
*
* @param {Err_Tournament_Cannot_Alter_SeatingInputs} inputs
* @param {{ locale?: "en" | "fr" | "es" | "pt" | "it" }} options
* @returns {LocalizedString}
*/
export const err_tournament_cannot_alter_seating = /** @type {((inputs?: Err_Tournament_Cannot_Alter_SeatingInputs, options?: { locale?: "en" | "fr" | "es" | "pt" | "it" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Err_Tournament_Cannot_Alter_SeatingInputs, { locale?: "en" | "fr" | "es" | "pt" | "it" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Impossible de modifier le placement dans cet état")
	if (locale === "es") return /** @type {LocalizedString} */ ("No se pueden modificar los asientos en este estado")
	if (locale === "pt") return /** @type {LocalizedString} */ ("Não é possível alterar os assentos neste estado")
	if (locale === "it") return /** @type {LocalizedString} */ ("Impossibile modificare la disposizione in questo stato")
	return /** @type {LocalizedString} */ ("Cannot alter seating in this state")
});